<template>
  <div style="margin: 30px">
    <v-row align="center">
      <v-col class="d-flex" cols="12" md="6">
        <div>
          <font-awesome-icon
            icon="angle-right"
            class="navIcon"
            size="2x"
            @click="addWeek(-1)"
          />
          <span class="dateRange">{{ currentWeekString }}</span>

          <font-awesome-icon
            icon="angle-left"
            class="navIcon"
            size="2x"
            @click="addWeek(1)"
          />
        </div>
      </v-col>
      <v-col class="d-flex" cols="4" sm="3" md="2"> <b>مکان تحویل:</b></v-col>
      <v-col class="d-flex" cols="8" sm="6" md="4">
        <v-select
          :items="places"
          item-text="name"
          item-value="id"
          v-model="deliveryPlaceId"
          @change="GetOrdersReport()"
        ></v-select>
      </v-col>
    </v-row>
    <div>
      <v-simple-table>
        <template v-slot:default>
          <!-- <thead>
            <tr>
              <th class="text-right" style="width: 20%">تاریخ</th>

              <th
                v-for="item in meals"
                :key="item.id"
                class="text-center"
                style="width: 25%"
              >
                {{ item.name }}
              </th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-for="item in 7" :key="item">
              <td style="width: 250px">{{ dateGenerator(item - 1) }}</td>
              <td style="padding-bottom: 25px">
                <div v-for="(meal, index) in meals" :key="index">
                  <template v-if="reports[item - 1][index] != undefined">
                    <div class="divider dchild">
                      <b> {{ meal.name }}</b>
                    </div>

                    <v-row
                      align="center"
                      v-for="(menu, index) in reports[item - 1][index]"
                      :key="index"
                    >
                      <v-col class="d-flex" cols="12" sm="6" md="3">
                        <b>{{ menu.food.name }}</b>
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="6" md="3">
                        کل سفارشات: {{ menu.totalOrders }}
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="6" md="3">
                        تحویل داده شده: {{ menu.totalDelivered }}
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="6" md="3">
                        باقی مانده: {{ menu.totalNoTahvil }}
                      </v-col>
                    </v-row>
                  </template>
                  <!-- <template v-else>
                    <v-row align="center">
                      <v-col cols="12" style="text-align: center">
                        <b>ناموجود </b></v-col
                      >
                    </v-row>
                  </template> -->
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetOrdersReport } from "@/api/orders";
import { GetBranchActiveMeals } from "@/api/meals";
import { GetBranchFoods } from "@/api/foods";
import moment from "moment-jalaali";
import { toArabicCharacter } from "@/utils/constants";
import { GetBranchDeliveryPlace } from "@/api/deliveryplace";

export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      reports: [],
      meals: [],
      menuDate: moment().startOf("week"),
      deliveryPlaceId: 0,
      places: [{ id: 0, name: "همه" }],
    };
  },
  created() {
    this.reports = Array(7);
    for (let i = 0; i < 7; i++) {
      this.reports[i] = Array(this.meals.length);
    }
    //this.selectedMenu.push(this.initMenu);
    if (this.currentBranch) {
      this.GetBranchDeliveryPlace();
      this.GetBranchActiveMeals();
      // this.GetBranchFoods();
      this.GetOrdersReport();
    }
  },
  computed: {
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    currentWeekString() {
      return "از " + this.startOfWeek + " تا " + this.endOfWeek;
    },
    startOfWeek() {
      return this.menuDate.format("jYYYY/jMM/jDD");
    },
    endOfWeek() {
      return moment(this.menuDate)
        .endOf("week")
        .format("jYYYY/jMM/jDD");
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },

  methods: {
    GetBranchDeliveryPlace() {
      return new Promise((resolve, reject) => {
        GetBranchDeliveryPlace(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.places = [...this.places, ...response.data.items];
            this.deliveryPlaceId = this.places[0].id;
            this.GetBranchActiveMeals();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    moveUp(index) {
      if (index > 0) {
        let temp = this.selectedMenu.slice();

        [temp[index - 1], temp[index]] = [
          this.selectedMenu[index],
          this.selectedMenu[index - 1],
        ];
        this.selectedMenu = temp.slice();
      }
    },
    // Move items down in the array
    moveDown(index) {
      if (index < this.selectedMenu.length - 1) {
        let temp = this.selectedMenu.slice();

        [temp[index], temp[index + 1]] = [
          this.selectedMenu[index + 1],
          this.selectedMenu[index],
        ];
        this.selectedMenu = temp.slice();
      }
    },
    addWeek(index) {
      this.menuDate = moment(this.menuDate).add(index, "weeks");
      this.GetOrdersReport();
    },

    GetBranchActiveMeals() {
      return new Promise((resolve, reject) => {
        GetBranchActiveMeals(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.meals = response.data.items;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    dateGenerator(offset) {
      return moment(this.menuDate)
        .add(offset, "days")
        .format("dddd jD jMMMM");
    },

    GetOrdersReport() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetOrdersReport(
          this.currentBranch.id,
          this.deliveryPlaceId,
          this.startOfWeek,
          this.endOfWeek
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const menus = response.data.items;
            this.reports = Array(7);
            for (let i = 0; i < 7; i++) {
              this.reports[i] = Array(this.meals.length);
            }
            const mealIds = this.meals.map((x) => x.id);

            for (const menu of menus) {
              const menuDate = moment(menu.tarikh, "jYYYY/jMM/jDD");
              const diff = menuDate.diff(moment(this.menuDate), "days");
              if (
                this.reports[diff][mealIds.indexOf(menu.mealId)] == undefined
              ) {
                this.reports[diff][mealIds.indexOf(menu.mealId)] = [];
              }
              this.reports[diff][mealIds.indexOf(menu.mealId)].push(menu);
            }
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>
<style scoped>
.navIcon {
  position: relative;
  top: 5px;
  cursor: pointer;
}
.dateRange {
  width: 250px;
  display: inline-block;
  text-align: center;
}
.v-data-table tr {
  margin-bottom: 10px;
}
</style>
